<form nz-form [formGroup]="form" (ngSubmit)="onFormSubmit()">
	<app-text-field
		[label]="LOCATION_CSV_LABELS[LocationCsvKeys.ssoLocationId]"
		[controlName]="LocationCsvKeys.ssoLocationId"
		[placeholder]="LOCATION_CSV_LABELS[LocationCsvKeys.ssoLocationId]"
		[required]="form.get(LocationCsvKeys.ssoLocationId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="LOCATION_CSV_LABELS[LocationCsvKeys.name]"
		[controlName]="LocationCsvKeys.name"
		[placeholder]="LOCATION_CSV_LABELS[LocationCsvKeys.name]"
		[required]="form.get(LocationCsvKeys.name)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-integer-field
		[label]="LOCATION_CSV_LABELS[LocationCsvKeys.displayOrder]"
		[controlName]="LocationCsvKeys.displayOrder"
		[placeholder]="LOCATION_CSV_LABELS[LocationCsvKeys.displayOrder]"
		[required]="form.get(LocationCsvKeys.displayOrder)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-checkbox-field
		[label]="LOCATION_CSV_LABELS[LocationCsvKeys.active]"
		[controlName]="LocationCsvKeys.active"
		[formGroup]="form"
	/>

	<nz-form-item>
		<nz-form-control [nzOffset]="7" [nzSpan]="12">
			<div class="buttons">
				<button nz-button nzType="primary" [disabled]="loading() || form.invalid">
					Submit
					@if (loading()) {
						<nz-spin nzSimple nzSize="small"></nz-spin>
					}
				</button>
				<button nz-button (click)="onClearClicked()">Clear</button>
			</div>
		</nz-form-control>
	</nz-form-item>
</form>
